import { useEffect, useState } from 'react'

// tailwindBreakpoints.ts
export const TAILWIND_BREAKPOINTS = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  '2xl': 1536
} as const

export type TailwindBreakpoint = keyof typeof TAILWIND_BREAKPOINTS

/**
 * Returns true if viewport is BELOW the given Tailwind breakpoint
 *
 * Example:
 *   useBelowBreakpoint('md') -> true on mobile & small tablets
 */
export const useBelowBreakpoint = (min: TailwindBreakpoint): boolean => {
  const [isBelow, setIsBelow] = useState(() => {
    if (typeof window === 'undefined') return false
    return window.innerWidth < TAILWIND_BREAKPOINTS[min]
  })

  useEffect(() => {
    const handler = () => {
      setIsBelow(window.innerWidth < TAILWIND_BREAKPOINTS[min])
    }

    window.addEventListener('resize', handler)
    return () => window.removeEventListener('resize', handler)
  }, [min])

  return isBelow
}
